<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="收货地址"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="用户名称">
            <el-input v-model="params.PersonName" placeholder="请输入用户名称" clearable />
          </el-form-item>
          <el-form-item label="所属省份">
            <el-input v-model="params.AddressPro" placeholder="请输入所属省份" clearable />
          </el-form-item>
          <el-form-item label="所属城市">
            <el-input v-model="params.AddressCity" placeholder="请输入所属城市" clearable />
          </el-form-item>
          <el-form-item label="所属区域">
            <el-input v-model="params.AddressArea" placeholder="请输入所属区域" clearable />
          </el-form-item>

          <el-form-item label="联系人">
            <el-input v-model="params.ContactName" placeholder="请输入联系人" clearable />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="params.ContactPhone" placeholder="请输入联系电话" clearable />
          </el-form-item>
          <el-form-item label="收货地址">
            <el-input v-model="params.ContactAddress" placeholder="请输入收货地址" clearable />
          </el-form-item>
                  
          <el-form-item label="默认地址">
            <el-select v-model="params.IsDefault" placeholder="请选择是否默认地址" clearable>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="table">
          <el-table-column prop="OrderId" label="序号" align="center" width="60" />
          <el-table-column prop="PersonName" label="用户名称" />
          <el-table-column prop="AddressPro" label="所属省份" />
          <el-table-column prop="AddressCity" label="所属城市" />
          <el-table-column prop="AddressArea" label="所属区域" />
          <el-table-column prop="ContactAddress" label="收货地址" />
          <el-table-column prop="ContactName" label="联系人" />
          <el-table-column prop="ContactPhone" label="联系电话" />
                
          <el-table-column prop="IsDefault" width="80px" label="默认地址" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.IsDefault == 1">是</el-tag>
              <el-tag type="danger" v-else>否</el-tag>
            </template>
          </el-table-column>
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/sale/personaddress").default,
        params: {
         PersonName: "",
         AddressPro: "",
         AddressCity: "",
         AddressArea: "",
         ContactAddress: "",
         ContactName: "",
         ContactPhone: "",
         IsDefault: null,
        },
      };
    },
    methods: {
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
  </script>